import { useContext, useEffect, useState } from "react"

import { TextField, Select, MenuItem, Button, FormControl, FormHelperText } from "@mui/material"

import { sendSupportRequest } from "/providers/studio-api"
import { AppContext } from "/providers/app-context"
import StyledPaper from '../paper.jsx'

const regardingOptions = [
  "What do you require assistance with?",
  "Creating templates",
  "Editing templates",
  "Creating passes",
  "Managing passes",
  "Notifying passes",
  "Smartix Scan App",
  "Billing / Invoices",
  "Subscription plans",
  "Account management",
  "Help text issue"
]

const RequestForm = () => {

  const { apiSource, apiKeys, setProcessing } = useContext(AppContext)

  const [subject, setSubject] = useState("")
  const [regarding, setRegarding] = useState(regardingOptions[0])
  const [message, setMessage] = useState("")
  const [subjectError, setSubjectError] = useState("")
  const [regardingError, setRegardingError] = useState("")
  const [messageError, setMessageError] = useState("")
  const [validating, setValidating] = useState(false)
  const [sent, setSent] = useState(false)

  const validate = () => {
    const trimmedSubject = subject.trim()
    const trimmedMessage = message.trim()
    let hasErrors = false

    setValidating(true)

    if (regarding === regarding[0]) {
      setRegardingError("Please choose an option so we can route your request.")
      hasErrors = true
    } else {
      setRegardingError("")
    }

    if (trimmedSubject.length <= 3) {
      setSubjectError("Subject must be longer than 3 characters.")
      hasErrors = true
    } else {
      setSubjectError("")
    }

    if (trimmedMessage.length <= 10) {
      setMessageError("Message must be longer than 10 characters.")
      hasErrors = true
    } else {
      setMessageError("")
    }

    return !hasErrors
  }

  useEffect(() => {
    if (validating) validate()
  }, [subject, message, regarding])

  const send = async () => {
    if (!validate()) return

    setProcessing(true)
    const result = await sendSupportRequest({ apiSource, apiKeys, subject, message, regarding })
    setProcessing(false)

    setSent(true)
  }

  const reset = () => {
    setSent(false)
    setMessage("")
    setSubject("")
    setRegarding(regardingOptions[0])
    setMessageError("")
    setSubjectError("")
    setRegardingError("")
    setValidating(false)
  }

  if (sent) return (
    <StyledPaper>
      <div className="flex flex-col justify-around items-center gap-5">
        <h2>Your support request has been sent.</h2>
        <p>We aim to respond to all requests within 24 hours Monday to Friday.</p>
        <Button onClick={reset} variant="contained" sx={{ width: 500 }}>Send Another Request</Button>
      </div>
    </StyledPaper>
  )

  return (
    <StyledPaper>
      <div className="flex flex-col justify-around items-center gap-5">
        <FormControl sx={{ width: 500 }} error={Boolean(regardingError)}>
          <Select
            value={regarding}
            onChange={e => setRegarding(e.target.value)}
            displayEmpty>
            {regardingOptions.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </Select>
          <FormHelperText>{regardingError}</FormHelperText>
        </FormControl>

        <TextField
          value={subject}
          onChange={e => setSubject(e.target.value)}
          sx={{ width: 500 }}
          required={true}
          label="subject"
          error={Boolean(subjectError)}
          helperText={subjectError}
          slotProps={{ inputLabel: { shrink: true } }}
        />

        <TextField
          value={message}
          onChange={e => setMessage(e.target.value)}
          sx={{ width: 500 }}
          multiline
          minRows={10}
          required={true}
          label="message"
          error={Boolean(messageError)}
          helperText={messageError}
          slotProps={{ inputLabel: { shrink: true } }}
        />

        <Button onClick={send} variant="contained" sx={{ width: 500 }}>Send Request</Button>

      </div>
    </StyledPaper>
  )
}

export default RequestForm
